import type { EnvironmentService } from '../application/EnvironmentService/EnvironmentService';
import { makeContext } from './shared/makeContext';

export const {
  Provider: EnvironmentServiceProvider,
  useContext: useEnvironmentService,
} = makeContext<EnvironmentService>('EnvironmentService');
